import React, {Component} from 'react';
import {Button, Card, Col, Input, notification, Table, Tag, Typography} from 'antd';
import './financialSealApps.css';
import {fetchRequest} from "../../../util/APIUtils";
import ServerError from "../../../common/ServerError";
import Highlighter from 'react-highlight-words';
import {SearchOutlined} from '@ant-design/icons';
import NotFound from "../../../common/NotFound";
import AccessError from "../../../common/AccessError";
import moment from "moment";
import {deliveryStatus, paymentStatus} from "../../../util/Helpers";

const {Text} = Typography;
class FinancialSealApps extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: [],
            total: 0,
            current: 1,
            pageSize: 5,
            pageSizeOptions: ['5', '10', '20', '50', '100'],
            loading: false,
            searchQuery: '',
            keySearchQuery: '',
            accessor: 'recordId',
            direction: 'desc',
        };
        this.fetchData = this.fetchData.bind(this);
        this.handleMenuClick = this.handleMenuClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.setSearchQuery = this.setSearchQuery.bind(this);
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData() {
        let self = this;
        this.setState({loading: true});
        const {accessor, direction, current, pageSize, searchQuery, keySearchQuery} = self.state;
        fetchRequest({}, `/token/fetchAllApps?page=${current - 1}&size=${pageSize}${keySearchQuery + searchQuery}&sort=${accessor},${direction}`)
            .then(response => {
                console.log(response)
                let {number, size, totalElements, content} = response.data;
                this.setState({
                    loading: false,
                    current: number + 1,
                    pageSize: size,
                    total: totalElements,
                    content
                });
            }).catch(error => {
            if (error.status === 404) {
                this.setState({notFound: true});
            } else if (error.response.status === 401) {
                notification.error({
                    message: 'Hata',
                    description: 'Kullanıcı adı veya şifre hatalı, tekrar deneyiniz!'
                });
            } else if (error.response.status === 400) {
                notification.error({
                    message: 'Hata',
                    description: error.response.data
                });
                this.setState({notFound: true});
            } else if (error.response.status === 403) {
                notification.error({
                    message: 'Hata',
                    description: "Bu sayfayı görmeye yetkiniz bulunmamaktadır."
                });
                this.setState({accessError: true});
            } else {
                this.setState({serverError: true});
            }
            this.setState({loading: false});
        });
    }

    onChange(pagination, filters, sorter) {
        let searchQuery = '';
        if (filters.kullaniciKimlikNo && filters.kullaniciKimlikNo.length > 0) {
            searchQuery = searchQuery + `&kullaniciKimlikNo=${filters.kullaniciKimlikNo[0]}`;
        }
        if (filters.kullaniciAd && filters.kullaniciAd.length > 0) {
            searchQuery = searchQuery + `&kullaniciAd=${filters.kullaniciAd[0]}`;
        }
        if (filters.kullaniciSoyad && filters.kullaniciSoyad.length > 0) {
            searchQuery = searchQuery + `&kullaniciSoyad=${filters.kullaniciSoyad[0]}`;
        }
        if (filters.barcode && filters.barcode.length > 0) {
            searchQuery = searchQuery + `&barcode=${filters.barcode[0]}`;
        }
        if (filters.kayitNumarasi && filters.kayitNumarasi.length > 0) {
            searchQuery = searchQuery + `&kayitNumarasi=${filters.kayitNumarasi[0]}`;
        }
        if (filters.kullaniciVergiNo && filters.kullaniciVergiNo.length > 0) {
            searchQuery = searchQuery + `&kullaniciVergiNo=${filters.kullaniciVergiNo[0]}`;
        }
        if (filters.unvan && filters.unvan.length > 0) {
            searchQuery = searchQuery + `&unvan=${filters.unvan[0]}`;
        }
        if (filters.kullaniciCepTelefonu && filters.kullaniciCepTelefonu.length > 0) {
            searchQuery = searchQuery + `&kullaniciCepTelefonu=${filters.kullaniciCepTelefonu[0]}`;
        }
        if (filters.teslimatSubesi && filters.teslimatSubesi.length > 0) {
            searchQuery = searchQuery + `&teslimatSubesi=${filters.teslimatSubesi[0]}`;
        }
        if (filters.odemeDurumu && filters.odemeDurumu.length > 0) {
            searchQuery = searchQuery + `&odemeDurumu=${filters.odemeDurumu[0]}`;
        }
        if (filters.teslimatDurumu && filters.teslimatDurumu.length > 0) {
            searchQuery = searchQuery + `&teslimatDurumu=${filters.teslimatDurumu[0]}`;
        }

        this.setState({
            searchQuery,
            accessor: sorter.field ? sorter.field : this.state.accessor,
            direction: sorter.order ? (sorter.order === 'ascend' ? 'asc' : 'desc') : this.state.direction,
            current: pagination.current,
            pageSize: pagination.pageSize
        }, () => this.fetchData());
    }

    handleSearch(selectedKeys, confirm, dataIndex) {
        confirm();
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    }

    handleReset(clearFilters) {
        clearFilters();
        this.setState({searchText: ''});
    }

    handleMenuClick(e) {
        let item = e.item;
    }

    getColumnSearchProps = (dataIndex, searchText) => ({
        filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
            <div style={{padding: 8}}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={searchText}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{width: 188, marginBottom: 8, display: 'block'}}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    icon={<SearchOutlined/>}
                    size="small"
                    style={{width: 90, marginRight: 8}}
                >
                    Ara
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{width: 90}}>
                    Temizle
                </Button>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{color: filtered ? '#1890ff' : undefined}}/>,
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select());
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{backgroundColor: '#ffc069', padding: 0}}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    setSearchQuery(text) {
        let self = this;
        self.setState({keySearchQuery: text, total: 0, current: 1, pageSize: 5}, () => self.fetchData());
    }

    render() {
        if (this.state.serverError) {
            return <ServerError/>;
        }

        if (this.state.notFound) {
            return <NotFound/>;
        }

        if (this.state.accessError) {
            return <AccessError/>;
        }

        const columns = [
            {
                title: '#',
                dataIndex: 'index',
                key: 'index',
                width: '3%',
                render: (text, record, index) => (
                    <label>{index + 1}</label>
                )
            },
            {
                title: 'Şube',
                dataIndex: 'teslimatSubesi',
                key: 'teslimatSubesi',
                width: '6%',
                sorter: true,
                ...this.getColumnSearchProps('teslimatSubesi', 'Şube ile ara'),
                render: (text, record) => (
                    <label>{record.teslimatSubesi}</label>
                )
            },
            {
                title: 'VKN',
                dataIndex: 'kullaniciVergiNo',
                key: 'kullaniciVergiNo',
                width: '10%',
                sorter: true,
                ...this.getColumnSearchProps('kullaniciVergiNo', 'Kullanıcı Vergi No ile ara'),
            },
            {
                title: 'TCKN',
                dataIndex: 'kullaniciKimlikNo',
                key: 'kullaniciKimlikNo',
                width: '5%',
                sorter: true,
                ...this.getColumnSearchProps('kullaniciKimlikNo', 'Kullanıcı VKN/TCKN ile ara'),
            },
            {
                title: 'Barkod',
                dataIndex: 'barcode',
                key: 'barcode',
                width: '5%',
                sorter: true,
                ...this.getColumnSearchProps('barcode', 'Barcode ile ara'),
                render: (text, record) => (<div>
                        <Tag color="gray">{record.barcode}</Tag>
                    </div>
                )
            },
            {
                title: 'Unvan',
                dataIndex: 'unvan',
                key: 'unvan',
                width: '15%',
                sorter: true,
                ...this.getColumnSearchProps('unvan', 'Unvan ile ara'),
            },
            {
                title: 'Ödeme',
                dataIndex: 'odemeDurumu',
                key: 'odemeDurumu',
                width: '6%',
                sorter: true,
                filters: [
                    {text: "Ödenmedi", value: "ODENMEDI"},
                    {text: "Ödendi", value: "ODENDI"}
                ],
                render: (text, record) => (<div>
                        <label>{paymentStatus(text)} </label>
                    </div>
                )
            },
            {
                title: 'Teslimat',
                dataIndex: 'teslimatDurumu',
                key: 'teslimatDurumu',
                width: '6%',
                sorter: true,
                filters: [
                    {text: "Teslim Edilmedi", value: "TESLIM_EDILMEDI"},
                    {text: "Teslim Edildi", value: "TESLIM_EDILDI"}
                ],
                render: (text, record) => (<div>
                        <label>{deliveryStatus(text)} </label>
                    </div>
                )
            },
            {
                title: 'Teslim Tarihi',
                dataIndex: 'teslimTarihi',
                key: 'teslimTarihi',
                width: '6%',
                sorter: true,
                render: (text, record) => (
                    <label>{record.teslimTarihi ? moment(record.teslimTarihi).format("DD-MM-YYYY") : ''}</label>
                )
            },
            {
                title: 'Tarih',
                dataIndex: 'updatedAt',
                key: 'updatedAt',
                width: '5%',
                sorter:true,
                render: (text, record) => (
                    <label>{moment(record.updatedAt).format("DD-MM-YYYY HH:mm")}</label>
                )
            }
        ];

        const {total, current, pageSize, pageSizeOptions, content} = this.state;

        return (
            <Col className="financial-container">
                <Col className="seal-app-page-content">
                    <Card>
                        <Table dataSource={content}
                               rowKey={record => record.recordId}
                               size="small"
                               columns={columns}
                               onChange={this.onChange}
                               loading={this.state.loading}
                               locale={{
                                   filterConfirm: 'Tamam',
                                   filterReset: 'Temizle'
                               }}
                               pagination={{
                                   total,
                                   current,
                                   pageSize,
                                   pageSizeOptions,
                                   showSizeChanger: true,
                                   showQuickJumper: true,
                                   showTotal: (total) => `Toplam ${total} kayıt`
                               }}
                        />
                    </Card>
                </Col>
            </Col>
        );
    }
}

export default FinancialSealApps;


// WEBPACK FOOTER //
// ./src/page/token/apps/FinancialSealApps.js